// ---- helpers ---------------------------------------------------------------
const parseLocalizedNumber = (str = "") => {
  const cleaned = String(str).replace(/\s+/g, "").replace(/[^\d,.\-]/g, "").replace(/,/g, ".");
  const m = cleaned.match(/-?\d+(\.\d+)?/);
  return m ? parseFloat(m[0]) : NaN;
};

const parseMoney = (text = "") => {
  return parseLocalizedNumber(text);
};

const parseWeightToGrams = (text = "") => {
  const t = String(text).trim().toLowerCase();
  const num = parseLocalizedNumber(t);
  if (Number.isNaN(num)) return NaN;
  if (t.includes("kg")) return num * 1000; 
  return num; 
};

// ---- core ------------------------------------------------------------------
const targetNode = document.querySelector("#ProductPrice");
if (!targetNode) {
  console.warn("[weight-price] #ProductPrice not found");
}

const config = { attributes: true, childList: true, subtree: true };

const recalc = () => {
  const priceEl = document.querySelector("#ProductPrice .money");
  const element = document.querySelector(".weight-price");
  if (!priceEl || !element) return;

  const currentCurrency = priceEl.dataset.currency || ""; 
  const weightStr = element.dataset.productWeight || "";   
  const grams = parseWeightToGrams(weightStr);
  const price = parseMoney(priceEl.textContent);

  if (!grams || Number.isNaN(grams) || Number.isNaN(price)) return; 
  
  const pricePer100g = (price / grams) * 100;
  
  let locale = "en-US";
  if (currentCurrency === "PLN") locale = "pl-PL";
  else if (currentCurrency === "EUR") locale = "de-DE"; 

  const formatted = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currentCurrency || "PLN",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(pricePer100g);

  element.textContent = formatted; 
};

const callback = (mutationList) => {
  for (const m of mutationList) {
    if (m.type === "childList" || m.type === "attributes") {
      recalc();
      break;
    }
  }
};

const observer = new MutationObserver(callback);
if (targetNode) observer.observe(targetNode, config);


document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", recalc) : recalc();
